//@constants
const actionTypes = require('constants/actionTypes');
// @helpers
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');
const errorActions = require('actions/brokerError');
const { getFormattedLanguage } = require('core/i18n').i18n;

const selectedOptionChanged = selectedOption => ({
    type: actionTypes.BROKER_ORDERS_AND_MOVEMENTS_SELECTED_OPTION_CHANGED,
    payload: {
        selectedOption
    }
});

function setContractNumber(selectedContract) {
    return {
        type: actionTypes.BROKER_ORDERS_AND_MOVEMENTS_SET_CONTRACT_NUMBER,
        payload: {
            selectedContract
        }
    };
}

function setAccessFrom(type) {
    return {
        type: actionTypes.BROKER_ORDERS_AND_MOVEMENTS_SET_ACCESS_FROM,
        payload: {
            type
        }
    };
}

function reset() {
    return {
        type: actionTypes.BROKER_ORDERS_AND_MOVEMENTS_RESET,
    };
}

function setStateOperationFilter(value) {
    return {
        type: actionTypes.BROKER_ORDERS_AND_MOVEMENTS_SET_STATE_OPERATIONS_FILTER,
        payload: value
    };
}

function setCheckContributions(value) {
    return {
        type: actionTypes.BROKER_ORDERS_AND_MOVEMENTS_SET_IS_CHECK_CONTRIBUTIONS,
        payload: value
    };
}

function setCheckSubscription(value) {
    return {
        type: actionTypes.BROKER_ORDERS_AND_MOVEMENTS_SET_IS_CHECK_SUBSCRIPTION,
        payload: value
    };
}

function setCheckReimbursement(value) {
    return {
        type: actionTypes.BROKER_ORDERS_AND_MOVEMENTS_SET_IS_CHECK_REIMBURSEMENT,
        payload: value
    };
}

function setCheckTransfer(value) {
    return {
        type: actionTypes.BROKER_ORDERS_AND_MOVEMENTS_SET_IS_CHECK_TRANSFER,
        payload: value
    };
}

function setMaxDateFilter(value) {
    return {
        type: actionTypes.BROKER_ORDERS_AND_MOVEMENTS_SET__MAX_DATE,
        payload: value
    };
}

function setMinDateFilter(value) {
    return {
        type: actionTypes.BROKER_ORDERS_AND_MOVEMENTS_SET__MIN_DATE,
        payload: value
    };
}

const fetchingContractList = () => (dispatch) => {
    dispatch({
        type: actionTypes.BROKER_ORDERS_AND_MOVEMENTS_GET_CONTRACT_LIST_FETCHING,
    });
};

const fetchContractListSuccess = (response) => (dispatch) => {
    dispatch({
        type: actionTypes.BROKER_ORDERS_AND_MOVEMENTS_GET_CONTRACT_LIST_SUCCESS,
        payload: response,
    });
};
const fetchContractListError = (error) => (dispatch) => {
    dispatch({
        type: actionTypes.BROKER_ORDERS_AND_MOVEMENTS_GET_CONTRACT_LIST_FAILURE,
        payload: error,
    });
};

const fetchContractList = () => (dispatch, getState) => {
    dispatch(fetchingContractList())
    const url = apiURLBuilder.getURL('investmentContracts');
    let requestData = {
        header: {
            version: 3,
            'Accept-Language': getFormattedLanguage()
        },
        query: {
            prod: 'VALORES_FONDOS_PLANES_Y_FUTUROS',
            stockRights: true,
            transferableToRobo: true,
            filtroSituacion: 'N'
        }
    };

    APIGet(dispatch, url, requestData).then(
      response => dispatch(fetchContractListSuccess(response)),
      error => dispatch(fetchContractListError(error))
    ).catch((error) => {
        const errorKey = get(error, ["body", "error"], "");
        dispatch(fetchContractListError(error));
        dispatch(errorActions.show("brokerAPIErrors-" + errorKey, true, history));
    });

  };

module.exports = {
    selectedOptionChanged,
    setCheckContributions,
    setCheckSubscription,
    setCheckReimbursement,
    setCheckTransfer,
    setContractNumber,
    setAccessFrom,
    setStateOperationFilter,
    reset,
    setMaxDateFilter,
    setMinDateFilter,
    fetchContractList
};
